import React, { useCallback, useState } from 'react';

import { GTMTracking, Modal } from '@common/ui/general';
import { useMediaQuery } from '@common/hooks';

import ShareModal from '@alumni_v2/ui/ShareModal/';

import crossIcon from '@alumni_v2/images/svg/cross.svg';
import shareIcon from '@alumni_v2/images/svg/share.svg';

import ACSConnectSuccess from './ACSConnectSuccess';
import CRTContent from './CRTContent';
import ProfileContent from './ProfileContent';
import SETContent from './SETContent';

import styles from './SidebarModal.module.scss';

const SidebarModal = ({
  isModalOpen,
  onModalClose,
  name,
  profileImg,
  preScalerRole,
  designation,
  location,
  preScalerText,
  preScalerImg,
  postScalerText,
  postScalerImg,
  salaryHike,
  sidebarModalStage,
  setSidebarModalStage,
  availableForQnA,
  programDetails,
  linkedinId,
  linkedinPost,
  content,
  collegeName,
  deegree,
  workExperience,
  userSlug,
  userId,
  videoBlog,
  rating,
}) => {
  const { tablet } = useMediaQuery();

  const [isShareOpen, setIsShareOpen] = useState(false);
  const [isClosing, setClosing] = useState(false);

  const shareData = {
    title: 'Scaler Review',
    text: `${name}'s Success Story from Scaler.`,
    // eslint-disable-next-line max-len
    url: `${window.location.origin}${window.location.pathname}?user=${userSlug}`,
  };

  const toggleShareModal = useCallback(() => {
    setIsShareOpen(!isShareOpen);
  }, [isShareOpen]);

  const shareHandler = useCallback(async () => {
    if (navigator.share) {
      try {
        await navigator.share(shareData);
      } catch (err) {
        console.log('Error in sharing', err);
      }
    } else {
      toggleShareModal();
    }
  }, [shareData, toggleShareModal]);

  const onClosing = useCallback(() => {
    setClosing(true);
    setTimeout(() => {
      onModalClose();
      setClosing(false);
    }, 350);
  }, [onModalClose]);

  const modalContentUi = () => {
    switch (sidebarModalStage) {
      case 0:
        return (
          <ProfileContent
            userId={userId}
            name={name}
            profileImg={profileImg}
            preScalerRole={preScalerRole}
            designation={designation}
            location={location}
            preScalerText={preScalerText}
            preScalerImg={preScalerImg}
            postScalerText={postScalerText}
            postScalerImg={postScalerImg}
            salaryHike={salaryHike}
            availableForQnA={availableForQnA}
            programDetails={programDetails}
            linkedinId={linkedinId}
            linkedinPost={linkedinPost}
            content={content}
            collegeName={collegeName}
            deegree={deegree}
            workExperience={workExperience}
            videoBlog={videoBlog}
            rating={rating}
            setSidebarModalStage={setSidebarModalStage}
            onModalClose={onModalClose}
            isModalOpen={isModalOpen}
          />
        );
      case 1:
        return <CRTContent onModalClose={onModalClose} />;
      case 2:
        return <SETContent onModalClose={onModalClose} />;
      case 3:
        return <ACSConnectSuccess />;
      default:
        return null;
    }
  };

  return (
    <>
      <ShareModal
        isOpen={isShareOpen}
        onModalClose={toggleShareModal}
        shareLink={shareData.url}
        shareMessage={shareData.text}
      />
      <Modal
        isOpen={isModalOpen}
        onClose={onClosing}
        position={tablet ? 'bottom' : 'right'}
        className={`
          ${styles.containerUi} ${isClosing ? styles.containerUiClosing : ''}
        `}
        containerClassName={styles.bodyUi}
        headerClassName={styles.crossHeader}
      >
        <div className={styles.controller}>
          {sidebarModalStage === 0 ? (
            <div className={styles.shareContainer}>
              <GTMTracking
                component="button"
                gtmEventType="cta"
                gtmEventAction="click"
                gtmEventResult="share_review_modal_open"
                gtmEventCategory="alumni_directory"
                className={styles.shareIcon}
                onClick={shareHandler}
                gtmEventData={{
                  click_type: 'share_review_modal_open',
                }}
              >
                <img src={shareIcon} alt="shareIcon" />
                {tablet ? null : <div>Share</div>}
              </GTMTracking>
            </div>
          ) : null}
          <GTMTracking
            component="button"
            gtmEventType="cta"
            gtmEventAction="click"
            gtmEventResult="card_details_close"
            gtmEventCategory="alumni_directory"
            className={styles.crossContainer}
            role="button"
            onClick={onModalClose}
            tabIndex="0"
            gtmEventData={{
              click_type: 'review_sidebar_close',
            }}
          >
            <img
              src={crossIcon}
              alt="Close"
              className={styles.crossIcon}
            />
          </GTMTracking>
        </div>

        <div className={styles.mainContainer}>
          {modalContentUi()}
        </div>
      </Modal>
    </>
  );
};

export default SidebarModal;
